import React from 'react';
import { injectIntl } from 'react-intl';
import DataTable from '../data-table/DataTable/DataTable';
import FormSubsection from '../FormSubsection/FormSubsection';
import { emblemChargeTableColumns } from '../../presenters/renewals/RenewalProductListPage/product-list-page-util';

const emblemChargeMapping = {
  COMPANY: 'company_charge',
  NAME: 'name_charge',
  OTHER: 'other_charge'
};

const getEmblemChargeData = (props) => {
  return [
    ...props.emblemCharges.map((emblemCharge) => ({
      label: props.intl.formatMessage({
        id: emblemChargeMapping[emblemCharge.chargeType.toUpperCase()]
      }),
      value: emblemCharge.price
    }))
  ];
};

const EmblemCharges = (props) => {
  return (
    <FormSubsection title={props.intl.formatMessage({ id: 'emblem_charges' })}>
      <DataTable
        columns={emblemChargeTableColumns}
        bodyData={getEmblemChargeData(props)}
      />
    </FormSubsection>
  );
};

export default injectIntl(EmblemCharges);
